export class ManageUserModel {
    email: string;
    id: string;
    selectedColumn: string;
    firstName: string;
    serviceClientId: string;
    licenseClientId: string;
    licenseStatus: string;
}
